export default "__VITE_ASSET__D2tN9ZkS__"